export default __webpack_public_path__ + "static/media/comic13_2.edb9d659.png";